<template>
  <div id="show-hospital">
    <b-row>
      <b-col md="6">
        <card class="stacked-form">
          <l-progress v-if="isLoading" :value="100" :height="20" class="mb-2" type="info" :animated="true" :striped="true"></l-progress>
          <div>
            <fg-input label="Name">
              <p>{{ dataAccount.name }}</p>
            </fg-input>
            <fg-input label="Email">
              <p>{{ dataAccount.email }}</p>
            </fg-input>
            <fg-input label="Role">
              <p>{{ dataAccount.roles !== null ? dataAccount.roles[0].name : '-' }}</p>
            </fg-input>
          </div>
          <div class="mt-5"></div>
          <b-button class="float-right" variant="primary" :href="'#/profile/change-password'"><font-awesome-icon icon="sync-alt"/> Change Pasword</b-button>
          <back-button/>
        </card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import {Switch} from 'element-ui'
  import {Progress as LProgress} from 'src/components/index'
  import Edit from '@/components/Buttons/Edit'
  import Back from '@/components/Buttons/Back'

  export default {
    components: {
      LProgress,
      EditButton: Edit,
      BackButton: Back,
      LSwitch: Switch
    },
    data () {
      return {
        isLoading: false,
        dataAccount: this.$store.getters['account/accountData']
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/Profile/Overview.vue